import { render, staticRenderFns } from "./VirtualProgress.vue?vue&type=template&id=b0b39b84&scoped=true&"
import script from "./VirtualProgress.vue?vue&type=script&lang=js&"
export * from "./VirtualProgress.vue?vue&type=script&lang=js&"
import style0 from "./VirtualProgress.vue?vue&type=style&index=0&id=b0b39b84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b39b84",
  null
  
)

export default component.exports